import _normalizeNbsp from "./normalizeNbsp.js";
import { decode as _decodeHtml } from "html-entities";
import _replaceUnderlineTags from "./replaceUnderlineTags.js";
import _replaceItalicTags from "./replaceItalicTags.js";
import _replaceBoldTags from "./replaceBoldTags.js";
import _stripTags from "./stripTags.js";
const stripTags = _stripTags;
const replaceBoldTags = _replaceBoldTags;
const replaceItalicTags = _replaceItalicTags;
const replaceUnderlineTags = _replaceUnderlineTags;
const decodeHtml = _decodeHtml;
const normalizeNbsp = _normalizeNbsp;
export default (function convertToPlainTextCustom(text, divider = "\n", removeTags = false, boldTag = "strong", italicTag = "em", underlineTag = "u", acceptColorInfo = false) {
  // Treat Quill/HTML non-breaking spaces as ordinary word spaces
  text = normalizeNbsp(text.toString());
  text = text.replace(/<p\b[^>]*>/gmi, "").replace(/<\/p>/gmi, divider);
  text = replaceBoldTags(text, "<" + boldTag + ">", "</" + boldTag + ">");
  text = replaceItalicTags(text, "<" + italicTag + ">", "</" + italicTag + ">");
  text = replaceUnderlineTags(text, "<" + underlineTag + ">", "</" + underlineTag + ">");
  if (acceptColorInfo) {
    text = text.replace(/<span class=\"ql-cursor\">.+<\/span>/g, "");
  } else {
    // Keep ruby/rt; strip other spans
    text = text.replace(/<(?!\/?(?:ruby|rt)\b)(?:span)(?:\s+[^>]*)?>|<\/span\s*>/gi, '');
  }

  //replace one or more spaces with a one space
  text = text.replace(/ +/g, " ");
  //replace spaces before punctuation
  text = text.replace(/(?<!-) ([.,])/g, "$1");
  if (removeTags) {
    return normalizeNbsp(decodeHtml(stripTags(text.trim())));
  } else {
    return normalizeNbsp(decodeHtml(text.trim()));
  }
});